














import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import Chart from '@/components/Chart/index.vue'
import ChartHeader from './ChartHeader.vue'

  @Component({
    name: 'Pie',
    components: { Chart, ChartHeader }
  })
export default class extends Vue {
    @Prop({ default: () => [] }) private colorList!: any
    @Prop({ default: () => [] }) private dataList!: any

    private legend: any[] = []
    private chartId: string = ''
    private option: any = {
      color: this.colorList || [],
      legend: {
        top: '0',
        left: 'right',
        textStyle: {
          color: '#999999',
          fontSize: 12
        },
        icon: 'circle',
        itemWidth: 6,
        itemHeight: 5
      },
      // animation: false,
      series: [{
        name: '',
        type: 'pie',
        radius: ['40%', '75%'],
        avoidLabelOverlap: false,
        top: 50,
        labelLine: {
          show: true
        },
        label: {
          show: true,
          formatter: function(value:any) {
            const p = value.percent
            return `${p}%`
          }
        },
        itemStyle: {
          borderColor: '#FFFFFF'
        },
        data: [
        ]
      }]
    }
    get chart() {
      return this.$refs.chart as any
    }
    @Watch('dataList', { immediate: true, deep: true })
    onDataChange(val: any) {
      if (!this.dataList.length) return
      this.option.series[0].data = []
      this.legend = []
      this.dataList
      this.dataList.map((item:any, index: number) => {
        this.option.series[0].data.push(item.values[0])
        this.legend.push({
          name: item.name,
          color: this.colorList[index]
        })
      })
      this.$nextTick(() => {
        (this.$refs.chart as any).update()
      })
    }
    created() {
      this.chartId = new Date().getTime() + '_' + parseInt(Math.random() * 10000000 + '')
    }
}
